import { Component, EventEmitter, Input, Output } from '@angular/core';
import { issueStatusLabel } from '../../../../helpers/issue-workflow';

const ISSUE_STATUS_CHIP: Record<string, { label: string; bg: string; fg: string }> = {
  open:     { label: 'Open',     bg: '#1036D61A', fg: '#1036D6' },
  resolved: { label: 'Resolved', bg: '#36AB1933', fg: '#186F03' },
  closed:   { label: 'Closed',   bg: '#E9ECF4',   fg: '#60698B' },
};

@Component({
  selector: 'app-issue-map-popup',
  templateUrl: './issue-map-popup.component.html',
  styleUrls: ['./issue-map-popup.component.scss'],
  standalone: false,
})
export class IssueMapPopupComponent {
  @Input() data: any = {};
  @Input() issues: any[] | null = null;
  @Output() issueSelected = new EventEmitter<any>();

  get isGrouped(): boolean {
    return Array.isArray(this.issues) && this.issues.length > 1;
  }

  get groupCount(): number {
    return this.issues?.length || 0;
  }

  get isPunchlist(): boolean {
    const sample = this.issues?.[0] || this.data || {};
    return sample?._kind === 'punchlist'
      || String(sample?.type || '').toLowerCase().includes('punchlist');
  }

  /** A pin of the project Issues tab (see issueMapMarkers). */
  get isProjectIssue(): boolean {
    const sample = this.issues?.[0] || this.data || {};
    return sample?._kind === 'issue';
  }

  get titleSingular(): string {
    if (this.isProjectIssue) return 'ISSUE';
    return this.isPunchlist ? 'PUNCH LIST ISSUE' : 'WARRANTY ISSUE';
  }

  get titlePlural(): string {
    if (this.isProjectIssue) return 'ISSUES';
    return this.isPunchlist ? 'PUNCH LIST ISSUES' : 'WARRANTY ISSUES';
  }

  statusFor(issue: any) {
    const s = (issue?.status || 'open') as string;
    // Contractor-workflow stages (Forwarded, Responded) read as words.
    return ISSUE_STATUS_CHIP[s] || { label: issueStatusLabel(s), bg: '#E9ECF4', fg: '#60698B' };
  }

  typeFor(issue: any): string {
    return issue?.type || '';
  }

  titleFor(issue: any): string {
    return issue?.title || '';
  }

  dateFor(issue: any): string | Date | null {
    return issue?.created_at || null;
  }

  thumbsFor(issue: any): any[] {
    const pics = (issue?.pictures || []) as any[];
    return pics.slice(0, 2);
  }

  get status() { return this.statusFor(this.data); }
  get type(): string { return this.typeFor(this.data); }
  get title(): string { return this.titleFor(this.data); }
  get date(): string | Date | null { return this.dateFor(this.data); }
  get thumbs(): any[] { return this.thumbsFor(this.data); }

  /** The pin sits at a geotagged photo's position, not the issue's own (for-map location_source). */
  get locationFromPhoto(): boolean { return this.data?.location_source === 'photo'; }

  onSelectIssue(issue: any): void {
    this.issueSelected.emit(issue);
  }

  onSeeMore(): void {
    this.issueSelected.emit(this.data);
  }
}
